import { ModalContextProvider } from "./ModalContext";
import { Title } from "./components";
import "../../designTokens/variables.css";
import { clsx } from "clsx";
import { AllIconName, IconType } from "../Icon";
import { StyledModal } from "./StyledModalComponents";

type ModalProps = {
  isOpen: boolean;
  disableBackgroundClick?: boolean;
  onClose: () => void;
  id?: string;
  testId?: string;
  className?: string;
  title: {
    text: string;
    iconName?: AllIconName;
    iconType?: IconType;
    bgColor?: string;
    id?: string;
  };
  size?: "small" | "medium" | "large" | "extra-large" | "fullscreen";
  alignment?: "top" | "center" | "bottom";
};

export enum LoadingModalTestIds {
  Container = "loading-modal",
}

export const LoadingModal = ({
  isOpen,
  onClose,
  className = "",
  testId,
  id,
  disableBackgroundClick,
  title,
  size = "large",
  ...modalProps
}: ModalProps) => {
  const modalSize = clsx({
    ["small"]: size === "small",
    ["medium"]: size === "medium",
    ["large"]: size === "large",
    ["extra-large"]: size === "extra-large",
    ["fullscreen"]: size === "fullscreen",
  });

  return (
    <ModalContextProvider value={{ onClose }}>
      <StyledModal
        isOpen={isOpen}
        {...(!disableBackgroundClick && { onBackgroundClick: onClose })}
        onEscapeKeydown={onClose}
        // @ts-expect-error ts(2769) library styled-react-modal doesn't expect className but it still works
        className={`${className} ${modalSize}`}
        data-testid={testId ?? LoadingModalTestIds.Container}
        id={id}
        {...modalProps}
      >
        <Title
          titleId={title.id}
          iconName={title.iconName}
          iconType={title.iconType}
          hasLoader={true}
        >
          {title.text}
        </Title>
      </StyledModal>
    </ModalContextProvider>
  );
};
